import type { Feature } from '@luna/gatekeeper';

export const creditCardDirectDebit: Feature = {
    enabled: true,
    _description: 'Enables sepa direct debit menu item in the credit card side menu',
};
